import React, { useState, useEffect } from "react";
import { Box, Button, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Dialog,styled } from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { marked } from 'marked';
import './EmailDialog.scss';
import { useSelector } from "react-redux";
import { Close, Subject } from "@mui/icons-material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const markdownToHtml = (markdown) => {
    return marked(markdown, { gfm: true, breaks: true })
};

const htmlToMarkdown = (html) => {
    const markdown = marked(html, { gfm: true });
};

function EmailDialog({ open, handleClose }) {
    const emailData = useSelector((state) => state.snackbar.emailData);
    const [to, setTo] = useState("");
    const [from, setFrom] = useState("");
    const [subject, setSubject] = useState("");
    const [markdownContent, setMarkdownContent] = useState("");
    const [editorContent, setEditorContent] = useState("");

    useEffect(() => {
        if (emailData) {
            setTo(emailData.to);
            setFrom(emailData.from);
            setSubject(emailData.subject);
            setMarkdownContent(emailData.body);
        }
    }, [emailData]);

    useEffect(() => {
        if (markdownContent) {
            const htmlContent = markdownToHtml(markdownContent);
            setEditorContent(htmlContent);
        }
    }, [markdownContent])


    const handleEditorChange = value => {
        setEditorContent(value);
        const markdown = htmlToMarkdown(value);
        setMarkdownContent(markdown);
    }
    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            maxWidth="sm"
            fullWidth={true}
            className="dialog-parent"
        >
            <DialogTitle
                className="dialog-title"
                id="customized-dialog-title"
            >
                Email Data Modification
            </DialogTitle>
            <IconButton aria-label="close" onClick={handleClose} className="dialog-close-button">
                <Close />
            </IconButton>
            <DialogContent className="dialog-content">
                <Box className='email-dialog-content-box'>
                    <TextField id="from-input" label='From' variant="outlined" value={from} onChange={(e) => setFrom(e.target.value)} className="from-textfield" />
                    <TextField id="to-input" label='To' variant="outlined" value={to} onChange={(e) => setTo(e.target.value)} className="to-textfield" />
                </Box>
                <TextField id="subject-input" label='Subject' variant="outlined" value={subject} onChange={(e) => setSubject(e.target.value)} className="subject-textfield" />
                <ReactQuill value={editorContent} onChange={handleEditorChange} className="rich-text-editor-body" theme="snow" />
            </DialogContent>
            <DialogActions className="button-holder">
                <Button className="cancel-button-success" variant="outlined" size="large" onClick={handleClose}>Cancel</Button>
                <Button className="submit-button-success" variant="contained" size="large" onClick={handleClose}>Send</Button>
            </DialogActions>
        </BootstrapDialog>
    )
}  

export default EmailDialog;